<template>
  <div class="senior" >
    <div class="tip-title">
      <p>高级检索条件搜索</p>
    </div>
    <div class="search-form">
      <div class="form-input-box">
        <div class="form-add">
          <button @click="addInput">+</button>
          <button @click="delInput">-</button>
        </div>
        <div class="form-stack">
          <el-select v-model="selectValue" placeholder="检索项">
            <el-option
              v-for="item in searchList"
              :key="item.englishName"
              :label="item.name"
              :value="item.englishName"
            >
            </el-option>
          </el-select>
          <el-input v-model="value" @change="changeValue(1)" class="form-search-value" placeholder="请先选择检索项，再输入想要检索的内容"></el-input>
        </div>
        <div class="form-stack form-stack-right" >
          <el-select v-model="selectOrAnd" class="fl">
            <el-option label="并且" :value="1"></el-option>
            <el-option label="或者" :value="0"></el-option>
          </el-select>
          <el-input v-model="valueCopy"  @change="changeValue(2)" class="form-search-value" placeholder="请输入不同的检索内容"></el-input>
        </div>
      </div>
    </div>
    <div class="search-senior-form" >
      <div>
        <SeniorInput
          v-for="(item,index) in searchList"
          v-show="index < showNumber"
          :key="item.name + seniorKey" :item="item"
          :searchIndex="index"
          :searchList="searchList"
          @changeInput="changeInput">
        </SeniorInput>
      </div>
    </div>
    <div class="senior-submit-box">
      <el-button class="search-senior-button search-senior-submit" @click="seniorBtn">检索</el-button>
      <el-button class="search-senior-button search-senior-clear" @click="seniorKeysBtn()">重置</el-button>
    </div>
  </div>
</template>

<script>
  import SeniorInput from "./SeniorInput";
  import {listSearchParam} from "../../utils/router/library.api";

  export default {
    name: "Senior",
    components: {SeniorInput},
    data(){
      return {
        value: '',
        valueCopy: '',
        showNumber: 1,
        devSelection: [],
        options: [],
        selectValue: "",
        selectOrAnd: 1,
        typeId: this.$store.state.typeId,
        searchList: [],
        esParamsList: [],
        seniorKey: 1652235841,
      }
    },
    methods:{
      addInput(){
        this.showNumber ++
        this.showNumber > 6 && (this.showNumber = 7)
      },
      delInput(){
        this.showNumber --
        this.showNumber < 1 && (this.showNumber = 1)
      },
      seniorKeysBtn() {
        this.selectValue = ''
        this.value = ''
        this.valueCopy = ''
        this.selectOrAnd = 1
        this.seniorKey = new Date().getTime()
      },
      seniorBtn() {
        this.$emit("baseSearch", this.esParamsList)
      },
      //监听检索项
      changeValue(e) {
        if(this.selectValue){
          let val = {
            searchName: this.selectValue,
            searchType: 0,
            searchRelation:  e == 1 ? 0 : this.selectOrAnd,
            searchValue:  e == 1 ? this.value : this.valueCopy,
            copy: e
          }
          this.changeInput(val)
        }else{
          this.$message('请选择检索项')
        }
      },
      //高级检索
      seniorInputAdd() {
        //生成es检索条件
        for (const key in this.searchList) {
          this.esParamsList.push({
            //检索名
            searchName: this.searchList[key].englishName,
            //检索值
            searchValue: "",
            //检索关系 0：or；1：and；
            searchRelation: 1,
            //检索类型 0 ：模糊查询；1：精确查询
            searchType: 0
          })
        }
      },
      //监听检索项
      changeInput(val) {
        if (val) {
          //是否存在  存在则修改
          var isShow = false
          this.esParamsList = this.esParamsList.map(res => {
            if(res.searchName == val.searchName && res.copy == val.copy){
              res.searchValue = val.searchValue
              res.searchRelation = val.searchRelation
              res.searchType = val.searchType
              isShow = true
            }
            return res
          })

          //不存在 新增
          if(val.searchValue){
            !isShow && this.esParamsList.push(val)
          }else{
            this.esParamsList = this.esParamsList.filter( res => !(res.searchName == val.searchName && res.copy == val.copy))
          }
        }
      },
      //查询检索项
      getSearchParams() {
        listSearchParam({
          typeId: this.typeId,
        }).then(res => {
          if (res && res.data.data) {
            res = res.data.data
            //去掉不显示的高级检索值
            res.map(data => {
              const arr = ['ID', '审核状态', '全文信息','主从', '元数据模板', 'OAI公开状态', 'OCR识别状态']
              const num = arr.findIndex(e => e == data.name)
              if (num < 0) {
                this.searchList.push(data)
              }
              return data
            })
            this.seniorInputAdd()
          }
        })
      },
    },
    created(){
      //生成检索条件
      this.getSearchParams()
    }
  }
</script>

<style lang="less" scoped>
  .senior {
    background: #f3f3f3;
    padding: 18px 52px;

    .search-senior-form {
      display: flex;
      flex-direction: column;
    }

    .tip-title {
      border-bottom: 1px solid #adadad;
      color: #5d5d5d;
      font-size: 22px;
      letter-spacing: 2px;
      padding-bottom: 14px;
    }

    .search-form {
      width: 100%;
      padding-top: 20px;
      display: flex;

      .form-input-box {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .form-stack {
        display: flex;
        flex-direction: row;

        /deep/ .el-select > .el-input {
          width: 150px;
          height: 34px;
          margin-left: 5px;
        }

        .form-search-value {
          width: 400px;
          margin-left: 5px;
        }
      }

      .form-stack-right {
        /deep/ .el-select > .el-input {
          width: 95px;
        }
      }

      .form-add {
        width: 100px;
        align-items: center;

        button {
          width: 20px;
          height: 20px;
          background-color: #fff;
          margin-left: 20px;
          border: solid 1px #ccc;
          cursor: pointer;
        }
      }
    }

    .senior-submit-box {
      text-align: right;
      margin-top: 20px;

      button {
        width: 165px;
        height: 34px;
        background-color: #654719;
        border-radius: 5px;
        color: #fff;
        letter-spacing: 5px;
      }
    }

    .btn-box {
      margin-top: 20px;
      position: absolute;
      right: 52px;

      .el-button {
        width: 164px;
        height: 34px;
        background-color: #654719;
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
</style>
